import type { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  field: { display: "flex", flexDirection: "column", gap: 5, minWidth: 0 },
  label: { fontWeight: 600, fontSize: 14 },
  hint: { color: theme.color.muted, fontSize: 13 },
  error: { color: theme.color.danger, fontSize: 13 },
}));

interface FieldProps {
  label: string;
  htmlFor: string;
  hint?: string;
  error?: string;
  children: ReactNode;
}

export const Field = ({
  label,
  htmlFor,
  hint,
  error,
  children,
}: FieldProps) => {
  const classes = useStyles();
  return (
    <div className={classes.field}>
      <label className={classes.label} htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint && !error && <span className={classes.hint}>{hint}</span>}
      {error && (
        <span className={classes.error} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};
